import { convert } from "./currencyConvertion";

export  function earningConverter({ earnings, base, rates }) {
    const todayEarningsValue = earningsTotal({ earnings: earnings?.result?.todayEarnings, base, rates });
    const weeklyEarningsValue = earningsTotal({ earnings: earnings?.result?.weeklyEarnings, base, rates });
    const monthlyEarningsValue = earningsTotal({ earnings: earnings?.result?.monthlyEarnings, base, rates });
    const totalEarningsValue = earningsTotal({ earnings: earnings?.result?.totalEarnings, base, rates });
    return {
        todayEarningsValue,
        weeklyEarningsValue,
        monthlyEarningsValue,
        totalEarningsValue
    };
}

export function earningsTotal({ earnings, base, rates }) {
    // Platform earnings per job = what the CLIENT paid (userPayableFare) minus what the WORKER
    // received (partnerTotalFare). This captures the FULL platform cut — client fee + worker
    // commission + the travel/visit fee, net of discounts — whereas the old formula summed only
    // userServiceFee + partnerServiceFee and OMITTED the travel fee, under-reporting the total.
    return earnings?.reduce(
        function (a, b) {
            const paid = parseFloat(b.userPayableFare || 0);
            const worker = parseFloat(b.partnerTotalFare || 0);
            if (b.currency != base) {
                return a + convert(base, rates, paid, b.currency) - convert(base, rates, worker, b.currency);
            }
            return a + (paid - worker);
        }, 0
    ).toFixed(2);
}